import { defineInlineEdit } from "../../../../../components/MobileList/inlineEdit";
import { SelectProvince } from "../../../../../components/Selectors/SelectProvince";

/**
 * Mirrors views/supplier-bills/suppliers/form — it PUTs `{name, province_id}`
 * and nothing else, so `balance` stays read-only even though the card shows it.
 *
 * The card renders `province_name` but the payload needs `province_id`, which
 * only the detail response carries. `hydrateOnOpen` fetches it when the pencil
 * is tapped and the same response is reused for the PUT, so a province change
 * still costs exactly one GET and one PUT.
 */
export default defineInlineEdit({
  api: "supplier",
  hydrate: true,
  toPayload: (detail) => ({
    name: detail.name ?? "",
    province_id: detail.province_id || null,
  }),
  fields: {
    name: { label: "الاسم", type: "text", required: true },
    province_name: {
      label: "المحافظة",
      type: "select",
      component: SelectProvince,
      required: true,
      hydrateOnOpen: true,
      getValue: (source) =>
        source?.province_id
          ? { id: source.province_id, name: source.province_name }
          : null,
      toPatch: (value) => ({ province_id: value?.id ?? null }),
    },
  },
});
